import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    voucher_appointments_subtitleDownload: 'Выходная форма ваучера',
    voucher_appointments_subtitle: 'Ваучеры',
    voucher_appointments_modalYes: 'Да',
    voucher_appointments_modalNo: 'Нет',
    voucher_appointments_requestFormId: '№ Заявления',
    voucher_appointments_voucherId: '№ Ваучера',
    voucher_appointments_childIIN: 'ИИН ребенка',
    voucher_appointments_childFIO: 'ФИО ребенка',
    voucher_appointments_childBirthday: 'Дата рождения',
    voucher_appointments_priorityCategory: 'Категория очередности',
    voucher_appointments_voucherIssueDate: 'Дата выдачи ваучера',
    voucher_appointments_voucherProlongDate: 'Срок дейс ваучера',
    voucher_appointments_voucherValidityPeriod: 'Срок действия ваучера',
    voucher_appointments_selectDO: 'Выбрать ДО',
    voucher_appointments_changeDO: 'Изменить ДО',
    voucher_appointments_transferDO: 'Зачислить в ДО',
    voucher_appointments_prolong: 'Продлить ваучер',
    voucher_appointments_enroll: 'Зачислить',
    voucher_appointments_DOName: 'Наименование ДО',
    voucher_appointments_annulledDate: 'Дата аннулирования',
    voucher_appointments_selfDeclinedDate: 'Дата отказа',
    voucher_appointment_actionsDownload: 'Скачать ваучер',
    voucher_appointments_decline: 'Отказаться от ваучера',
    voucher_applications_successDeclineVoucher: 'Успешно получилось отклонить ваучер',
    voucher_appointments_modalBodyReservePlace:
      'Вы действительно хотите зачислиться в дошкольную организацию {{name}}, группа {{group_name}}, адрес {{address}}',

    //modal
    voucher_applications_modalBodyDeclineVoucher:
      'При отказе, полученный ваучер будет аннулирован. Для зачисления в ДО нужно будет встать в очередь заново',
    voucher_applications_modalTitleDeclineVoucher:
      'Вы действительно хотите отказаться от ваучера? ',
    voucher_applications_modalTitleProlong: 'Продление ваучера',
    voucher_applications_modalBodyProlong: 'Вы действительно хотите продлить ваучер?',

    // error
    voucher_applications_errorDeclineVoucher: 'Не удалось отклонить ваучер',
    voucher_appointments_errorLoad: 'Ошибка при загрузке данных',
    voucher_applications_error_prolongVoucher: 'Не удалось продлить ваучер',
    runtime_kindergarten_voucher_contingent_applicant_or_enrolled:
      'Отказаться от ваучера невозможно, т.к. {{fullName}} {{iin}} зачислен в дошкольную организацию.',
    runtime_user_must_sing_own_signature:
      'Пользователь может подписывать только своей подписью',
    runtime_signature_data_was_changed: 'данные в подписи были подменены',
    runtime_signature_is_invalid: 'Ошибка при подписании',
    voucher_appointments_error_reserve_place:'Не удалось зачислиться в ДО',
  },
  kk: {
    voucher_appointments_subtitleDownload: 'Ваучердің шығу формасы',
    voucher_appointments_subtitle: 'Ваучерлер',
    voucher_appointments_modalYes: 'Иә',
    voucher_appointments_modalNo: 'Жоқ',
    voucher_appointments_requestFormId: 'Өтініш №',
    voucher_appointments_voucherId: 'Ваучер №',
    voucher_appointments_childIIN: 'Баланың ЖСН-і',
    voucher_appointments_childFIO: 'Баланың аты-жөні',
    voucher_appointments_childBirthday: 'Туған күні',
    voucher_appointments_priorityCategory: 'Кезектілік санаты',
    voucher_appointments_voucherIssueDate: 'Ваучер берілген мерзімі',
    voucher_appointments_voucherValidityPeriod: 'Ваучердың жарамдылық мерзімі',
    voucher_appointments_selectDO: 'МДҰ таңдау',
    voucher_appointments_changeDO: 'МДҰ өзгерту',
    voucher_appointments_transferDO: 'МДҰ-ға тіркеу',
    voucher_appointments_prolong: 'Ваучерді ұзарту',
    voucher_appointments_enroll: 'Қабылдау',
    voucher_appointments_DOName: 'Ұйым атауы',
    voucher_appointments_annulledDate: 'Жою күні',
    voucher_appointments_selfDeclinedDate: 'Бас тарту күні',
    voucher_appointment_actionsDownload: 'Ваучерды жүктеу',
    voucher_appointments_decline: 'Ваучерден бас тарту',
    voucher_applications_successDeclineVoucher: 'Ваучерден бас тарту сәтті аяқталды',
    voucher_appointments_modalBodyReservePlace:'Сіз шынымен де мектепке дейінгі ұйымға жазылғыңыз келе ме {{name}}, топ {{group_name}}, мекен-жай {{address}}\n',

    //modal
    voucher_applications_modalBodyDeclineVoucher:
      'Бас тартқан жағдайда берілген ваучер жойылады. Балаңызды МДҰ-ға тіркеу үшін кезекке қайта тұруыңыз қажет болады.',
    voucher_applications_modalTitleDeclineVoucher:
      'Сіз ваучерден бас тартқыңыз келетініне сенімдісіз бе?',
    voucher_applications_modalTitleProlong: 'Ваучерді ұзарту',
    voucher_applications_modalBodyProlong: 'Сіз ваучерді шынымен ұзартқыңыз келе ме?',

    //error
    voucher_applications_errorDeclineVoucher: 'Ваучерден бас тарту мүмкін болмады',
    runtime_kindergarten_voucher_contingent_applicant_or_enrolled:
      'Ваучерден бас тарту мүмкін емес, себебі {{fullName}} {{iin}} МДҰ-да тіркелген',
    voucher_appointments_errorLoad: 'Деректерді жүктеуде қателік орын алды',
    voucher_applications_error_prolongVoucher: 'Ваучерді ұзарту мүмкін болмады',
    runtime_user_must_sing_own_signature: 'Пайдаланушының ЖСН ЭЦҚ-ға сәйкес емес',
    runtime_signature_data_was_changed: 'қол қою деректері ауыстырылды',
    runtime_signature_is_invalid: 'Қол қою кезінде қате',
    voucher_appointments_error_reserve_place:'МДҰ-ға тіркелу мүмкін болмады',
  }
});
